import type Image from "@travily/types/shared/Image";
import { CoverImage } from "@ui/components/CoverImage";
import { FullBleed } from "@ui/components/FullBleed";
import { type SwooshColor, SwooshStrip } from "@ui/components/Swoosh";
import { CoverMapBubble } from "./CoverMapBubble";

export type CoverKind = "custom" | "map" | "swoosh";
export type CoverCity = { name: string; country_code: string };

export interface CoverFrameProps {
  /** Which cover to render, decided server-side (see ProfileCoverResolvable). */
  coverKind: CoverKind;
  /** The resolved custom or map image; null for swoosh. */
  coverImage: Image | null;
  /** Current city, for the map speech bubble; null when restricted / no trip. */
  coverCity: CoverCity | null;
  /** Swoosh colour for the per-profile-type default cover. */
  swooshColor: SwooshColor;
}

/**
 * Profile cover: a custom upload, the current-location map (with the centred
 * speech-bubble overlay), or the per-type swoosh fallback. Replaces the inline
 * cover logic shared by the family / individual / community profile frames.
 */
export function CoverFrame({ coverKind, coverImage, coverCity, swooshColor }: CoverFrameProps) {
  if (coverKind !== "swoosh" && coverImage) {
    return (
      <FullBleed>
        <div className="relative">
          <CoverImage image={coverImage} priority />
          {coverKind === "map" && coverCity ? <CoverMapBubble city={coverCity.name} /> : null}
        </div>
      </FullBleed>
    );
  }

  return (
    <FullBleed className="md:hidden">
      <SwooshStrip color={swooshColor} />
    </FullBleed>
  );
}
